import React from 'react';

import { Spacing } from '@vkontakte/vkui';

import { DescriptionProps } from './types';
import { TextContent } from '../../../components/TextContent';

export const Description: React.FC<DescriptionProps> = ({ temperamentData }) => {
  return (
    <div style={{ margin: '0 26px' }}>
      <TextContent text={temperamentData.description} />
      <Spacing size={32}/>
      <TextContent text={temperamentData.abilities} title='Способности'/>
      <Spacing size={32}/>
      <TextContent text={temperamentData.values} title='Ценности и личностные качества'/>
      <Spacing size={32}/>
      <TextContent text={temperamentData.preferences} title='Предпочитаемые виды деятельности'/>
      <Spacing size={32}/>
      {temperamentData.style &&
        <>
          <TextContent text={temperamentData.style} title='Стиль работы'/>
          <Spacing size={32}/>
        </> 
      }
      <TextContent text={temperamentData.professions} title='Профессии'/>
    </div>
  );
}; 
